export const endpoint = "";
export const HOME = `${endpoint}/home`;
export const LAUNCHPAD = `${endpoint}/launchpad`;
export const LAUNCHPAD_CREATE_FAIR = `${endpoint}/launchpad-create-fair`;
export const LAUNCHPAD_CREATE_SUB_SCIPTION_POOL = `${endpoint}/launchpad-create-subscription-pool`;

export const LAUNCHPAD_CREATE_TOKEN = `${endpoint}/launchpad-create-token`;
export const LAUNCHPAD_CREATE_DUTCH_AUTION = `${endpoint}/launchpad-create-dutch-aution`;
export const LAUNCHPAD_LIST = `${endpoint}/launchpad-list`;
export const LAUNCHPAD_GC = `${endpoint}/launchpad-gc`;
export const PRIVATESALE = `${endpoint}/privatesale-create`;
export const PRIVATESALE_LIST = `${endpoint}/privatesale-list`;

export const PINKLOCK = `${endpoint}/pinklock`;
export const PINKLOCK_TOKEN = `${endpoint}/pinklock-token`;
export const PINKLOCK_LIST = `${endpoint}/pinklock-list`;
export const PINKLOCK_DETAIL = `${endpoint}/pinklock-detail`;
export const PINKLOCK_RECORD = `${endpoint}/pinklock-record`;
export const AIRDROP = `${endpoint}/airdrop`;
export const AIRDROP_LIST = `${endpoint}/airdrop-list`;
export const LEADER_BOARD = `${endpoint}/leaderboard`;
export const ANTIBOT = `${endpoint}/antibot`;
export const MULTI_SENDER = `${endpoint}/multisender`;
export const LOGIN = `${endpoint}/LOGIN`;

